// extracted by mini-css-extract-plugin
export default {"popupWrapper":"WellListPanelAsPopup_popupWrapper__FTqvR"};